import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <button className="btn btn-outline-warning" type="button" data-bs-toggle="collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={() => logout({ returnTo: window.location.origin.startsWith('file://') ? 'file:///electron-auth0-redirect' : window.location.origin })}>Log Out</button>
  );
};

export default LogoutButton;
